class FileUploadCtrl {

    constructor($scope, $uibModalInstance, folderId, files, currentDirectoryListing) {

        $scope = $scope;
        $scope.folderId = folderId;
        $scope.files = files;
        $scope.currentDirectoryListing = currentDirectoryListing;
        this.$uibModalInstance = $uibModalInstance;

        $scope.cancel = this.cancel.bind(this);

    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm").controller("FileUploadCtrl", ['$scope', '$uibModalInstance', 'folderId', 'files', 'currentDirectoryListing', FileUploadCtrl]);
